// 9fbef606107a605d69c0edbcd8029e5d
const getReviewRatingsData = (tileData = {}) => {
  const { TCPBazaarVoiceRating, TCPBazaarVoiceReviewCount } = tileData;
  return {
    ratings: TCPBazaarVoiceRating || 0,
    reviewCount: TCPBazaarVoiceReviewCount || 0,
  };
};
export default getReviewRatingsData;
